import { useSelector } from "react-redux";
import ModalEditPersonalInfo from "../modals/ModalEditPersonalInfo";
import ModalEditEmail from "../modals/ModalEditEmail";
import ModalEditMobile from "../modals/ModalEditMobile";
import ModalEditMobileWarning from "../modals/ModalEditMobileWarning";
import ModalEditMobileVerifyOne from "../modals/ModalEditMobileVerifyOne";
import ModalEditMobileVerifyTwo from "../modals/ModalEditMobileVerifyTwo";
import ModalLogOut from "../modals/ModalLogOut";
import ModalLogOutCourier from "../modals/ModalLogOutCourier";
import ModalAddresses from "../modals/ModalAddresses";
import ModalAddAddress from "../modals/ModalAddAddress";
import ModalAddCustomAddress from "../modals/ModalAddCustomAddress";
import ModalSuccessMsg from "../modals/ModalSuccessMsg";
import ModalErrorMsg from "../modals/ModalErrorMsg";
import ModalProductRating from "../modals/ModalProductRating";
import ModalStory from "../modals/ModalStory";

const ImportModals = () => {

	const { isOpen: isModalEditPersonalInfoOpen } = useSelector(state => state.modalEditPersonalInfo);
	const { isOpen: isModalEditEmailOpen } = useSelector(state => state.modalEditEmail);
	const { isOpen: isModalEditMobileOpen } = useSelector(state => state.modalEditMobile);
    const { isOpen: isModalEditMobileWarningOpen } = useSelector(state => state.modalEditMobileWarning);
    const { isOpen: isModalEditMobileVerifyOneOpen } = useSelector(state => state.modalEditMobileVerifyOne);
    const { isOpen: isModalEditMobileVerifyTwoOpen } = useSelector(state => state.modalEditMobileVerifyTwo);
    const { isOpen: isModalLogOutOpen } = useSelector(state => state.modalLogOut);
    const { isOpen: isModalLogOutCourierOpen } = useSelector(state => state.modalLogOutCourier);
    const { isOpen: isModalAddressesOpen } = useSelector(state => state.modalAddresses);
    const { isOpen: isModalAddAddressOpen } = useSelector(state => state.modalAddAddress);
    const { isOpen: isModalAddCustomAddressOpen } = useSelector(state => state.modalAddCustomAddress);
    const { isOpen: isModalSuccessMsgOpen } = useSelector(state => state.modalSuccessMsg);
    const { isOpen: isModalErrorMsgOpen } = useSelector(state => state.modalErrorMsg);
    const { isOpen: isModalProductRatingOpen } = useSelector(state => state.modalProductRating);
    const { isOpen: isModalStoryOpen } = useSelector(state => state.modalStory);

    return (
        <div id={'base-box-all-modals'}>
            {isModalEditPersonalInfoOpen && <ModalEditPersonalInfo />}
            {isModalEditEmailOpen && <ModalEditEmail />}
            {isModalEditMobileOpen && <ModalEditMobile />}
            {isModalEditMobileWarningOpen && <ModalEditMobileWarning />}
            {isModalEditMobileVerifyOneOpen && <ModalEditMobileVerifyOne />}
            {isModalEditMobileVerifyTwoOpen && <ModalEditMobileVerifyTwo />}
            {isModalLogOutOpen && <ModalLogOut />}
            {isModalLogOutCourierOpen && <ModalLogOutCourier />}
            {isModalAddressesOpen && <ModalAddresses />}
            {isModalAddAddressOpen && <ModalAddAddress />}
            {isModalAddCustomAddressOpen && <ModalAddCustomAddress />}
            {isModalSuccessMsgOpen && <ModalSuccessMsg />}
            {isModalErrorMsgOpen && <ModalErrorMsg />}
            {isModalProductRatingOpen && <ModalProductRating />}
            {isModalStoryOpen && <ModalStory />}
        </div>
    );
}

export default ImportModals;
